import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListResult } from '../api/core/list-result';
import { BACKEND_URL } from '../app.config';

import { ProgressStatus } from '../api/data-model';

@Injectable()
export class ProgressStatusService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) { }

  getList(
      keyword: string='',
      sorting: string = '',
      skipCount: number = 0,
      maxResultCount: number = 100
    ): Observable<ListResult<ProgressStatus>> {
      return this.http.get<ListResult<ProgressStatus>>(`${this.baseUrl}/api/app/progress-status`, {
        params: {
          keyword,
          sorting,
          skipCount: skipCount.toString(),
          maxResultCount: maxResultCount.toString(),
        },
      });
    }
}
